import type { Messages } from './en';

/** 額外的閒聊話題，接在每個角色的輪播後面。格式與 `talks[...].topics` 相同。 */
type Topic = { say: string; choices: { t: string; reply: string }[] };
const topic = (say: string, a: [string, string], b: [string, string], c: [string, string]): Topic => ({
  say,
  choices: [a, b, c].map(([t, reply]) => ({ t, reply })),
});

export const zhTWTalks3: Pick<Messages, 'talks3'> = {
  talks3: {
    librarian: [
      topic('你知道怎麼在書架上找書嗎？', ['不太會耶，可以教我嗎？', '每本書的書背上都有號碼。號碼一樣的住在一起，就像鄰居一樣！'], ['是照作者的名字排嗎？', '小說的話是喔，照作者的姓氏排。'], ['我都找封面最亮的那本。', '哈！有時候這招也有用。']),
      topic('睡前看書可以幫助睡眠喔。', ['我每天晚上都來看一章！', '真好。選本輕鬆的，不要選恐怖的喔！'], ['為什麼會有幫助？', '眼睛可以離開螢幕休息，腦袋也會慢慢放鬆。'], ['除非那本書太好看了！', '那就會變成「再看一章就好」，一路看到半夜！']),
    ],
    coach: [
      topic('團隊合作就是幫別人發光，不只是自己。', ['我會多傳球！', '這才是真正的好隊友。'], ['怎樣才是好隊長？', '會傾聽、會幫大家加油，而且第一個出手幫忙。'], ['我可以當睡覺隊長嗎？', '哈！先當伸展操隊長吧。']),
      topic('輸球也是學習的一部分。', ['下次我再試一次。', '沒錯。每個冠軍都先輸過很多次。'], ['輸了以後要怎麼保持冷靜？', '深呼吸、握握手，然後想一件可以進步的地方。'], ['我要怪那顆球。', '球是無辜的啦！哈！']),
    ],
    clerk: [
      topic('自備購物袋，一起救地球！', ['下次我會帶一個來。', '海龜都要謝謝你，你是牠們的英雄。'], ['塑膠袋為什麼不好？', '它們要好幾百年才會分解。'], ['我可以把零食裝在帽子裡嗎？', '很有創意！不過用袋子比較方便啦。']),
      topic('我們出了新的草莓奶茶喔！', ['哇，我想喝喝看！', '下次特價的時候，我幫你留一杯。'], ['會很甜嗎？', '可以調甜度，我推薦半糖。'], ['下一個是草莓奶茶披薩嗎？', '拜託不要。哈哈。']),
    ],
    grandma: [
      topic('以前我孩子的衣服都是我自己縫的。', ['哇，好厲害！', '謝謝你，乖孩子。一根針加上耐心，什麼都做得出來。'], ['可以教我縫釦子嗎？', '當然好！星期天來找我吧。'], ['你有縫過超級英雄的披風嗎？', '有一次！你的⋯⋯嗯，某個人的爸爸穿了好幾年呢！']),
      topic('這些鴿子都知道什麼時候吃午餐。', ['牠們好聰明！', '這些小傢伙比看起來還聰明。'], ['你都餵牠們吃什麼？', '一點點種子就好。麵包對牠們不好喔。'], ['牠們會送你禮物嗎？', '只會送羽毛！哈！']),
    ],
    bo: [
      topic('我找到一隻瓢蟲！牠有七個點點！', ['好酷！要輕輕的喔。', '我會的！我要讓牠飛走。'], ['瓢蟲會吃東西嗎？', '媽媽說牠們會吃傷害植物的小蟲蟲！'], ['我們叫牠點點好不好？', '點點！點點掰掰！']),
      topic('你會側翻嗎？', ['我試試看！看我！', '哇！你差一點就成功了！'], ['可以教我嗎？', '先手再腳！像海星一樣！'], ['我只會前滾翻。', '哈哈哈！我也是！']),
    ],
    sister: [
      topic('我可以同時當公主「和」消防員嗎？', ['你想當什麼都可以！', '耶！公主消防員！'], ['你會先做什麼？', '先救屋頂上的貓咪，然後喝下午茶！'], ['除非我可以當那隻龍。', '一隻好心的龍嗎？好啊！']),
      topic('我的牙齒掉了！你看！', ['哇，你長大了耶！', '嘻嘻，笑起來感覺好奇怪！'], ['會痛嗎？', '一點點而已。媽媽給我吃冰淇淋！'], ['可以給我嗎？', '不行！要丟到屋頂上，新牙才會長得好！']),
    ],
    dad: [
      topic('我像你這麼大的時候，想當飛行員。', ['你總有一天還是可以開飛機！', '哈！先從紙飛機開始吧。'], ['那你為什麼沒當？', '後來發現我更喜歡動手做東西。人生會變的嘛！'], ['你現在已經在駕駛遙控器了。', '沙發機長報到！']),
      topic('我們來計畫今年暑假的家庭旅行吧。', ['好耶！去有海灘的地方！', '那就海灘。我來查查火車。'], ['阿嬤也可以一起去嗎？', '當然啊。家庭旅行就是大家都要去。'], ['去月球？', '太貴了啦！那還是海灘吧。']),
    ],
    xiaoyu: [
      topic('我畫了一個會保護大家的機器人。', ['我好想看！', '⋯⋯好。我明天帶來。'], ['它有什麼超能力？', '它可以讓吵鬧的地方安靜下來。還會抱抱。'], ['它可以幫我寫功課嗎？', '哈⋯⋯不行。想得美。']),
      topic('林老師說我隨時都可以找她聊天。', ['太好了，她真的很關心你。', '嗯。我不知道大人也可以那樣聽人說話。'], ['你會去找她聊嗎？', '也許吧。如果你陪我去的話。'], ['你也可以找我聊啊。', '⋯⋯謝謝。真的。']),
    ],
    nurse: [
      topic('吃早餐可以讓大腦整個早上都有能量。', ['我每天都會吃早餐！', '太棒了。蛋、水果或稀飯都很好。'], ['如果我不餓怎麼辦？', '吃一點點就好，像是香蕉配牛奶。'], ['糖果算嗎？', '很可惜，不算！糖果是點心，不是早餐。']),
      topic('如果你難過了很久，找人聊聊會有幫助。', ['我會找我信任的人聊。', '很好。把心情說出來，就會輕鬆一點。'], ['我可以找誰聊？', '爸爸媽媽、老師、輔導老師，或是我。'], ['我可以跟我的寵物說嗎？', '寵物是很棒的聽眾！不過也要找一個人說喔，好嗎？']),
    ],
    musicTeacher: [
      topic('每天練一點點，比一個禮拜練一大堆還好。', ['那就每天十分鐘！', '完美。你的手指會記住的。'], ['要多久才會變厲害？', '每個人都不一樣。好好享受每一小步！'], ['我可以在夢裡練習嗎？', '哈！夢中音樂會算一點點。']),
      topic('哪首歌讓你最開心？', ['只要能跟朋友一起唱的都好！', '音樂一起分享更好聽，對吧？'], ['我們可以一起學新歌嗎？', '可以！下堂課我們來學一首民謠。'], ['垃圾車的〈少女的祈禱〉！', '哈！那首的旋律真的很好聽。']),
    ],
    lifeguard: [
      topic('你知道怎麼仰漂嗎？', ['還不會，可以教我嗎？', '放輕鬆，眼睛看上面，手張開像星星一樣。'], ['為什麼學漂浮很重要？', '如果你累了，漂浮可以讓你休息，還能呼救。'], ['我漂起來像石頭一樣。', '哈！石頭也可以學啊。肩膀放鬆。']),
      topic('防曬很重要，陰天也一樣。', ['我出門前會擦！', '聰明。你的皮膚會謝謝你。'], ['為什麼陰天也要？', '陽光會穿過雲層喔。'], ['我可以戴帽子就好嗎？', '帽子「加」防曬乳，最強組合！']),
    ],
    barista: [
      topic('想看我怎麼在奶泡上拉出愛心嗎？', ['好啊，拜託！', '慢慢倒，然後往前一拉⋯⋯登登！愛心！'], ['很難學嗎？', '我每天早上練，練了一個月。'], ['你可以拉一隻恐龍嗎？', '嗯⋯⋯會是一隻歪歪扭扭的恐龍！']),
      topic('下雨天是店裡最忙的時候。', ['因為下雨天最適合喝熱可可了！', '沒錯！熱飲配一本好書。'], ['大家最常點什麼？', '熱可可和蜂蜜蛋糕。'], ['雨傘也會點餐嗎？', '只有很高級的雨傘會，哈哈。']),
    ],
    giftClerk: [
      topic('親手寫的卡片是最珍貴的禮物。', ['我要寫一張卡片給媽媽！', '她一定會珍藏一輩子，我保證。'], ['我應該寫什麼？', '一個回憶、一句謝謝，還有一個願望。'], ['我可以在上面畫一隻貓嗎？', '有貓咪的卡片都會更可愛！']),
      topic('我們現在都用回收紙包禮物喔。', ['這個點子好棒！', '漂亮又愛地球。'], ['你們用什麼紙？', '舊地圖和舊報紙，看起來超有型的。'], ['我可以把我妹妹包起來嗎？', '哈哈，拜託不要！']),
    ],
    deptClerk: [
      topic('衣服好好摺，就能穿得更久。', ['我今天晚上就來摺衣服！', '你媽媽一定會嚇一跳。'], ['T恤要怎麼快速摺好？', '兩邊往內摺，再對摺，像一個小信封。'], ['我的衣服都堆成一大堆。', '衣服堆成一座山！該去爬山了。']),
      topic('穿不下的衣服可以捐出去喔。', ['我要把我的送給需要的人。', '你真大方。'], ['可以去哪裡捐？', '百貨公司入口有一個捐衣箱。'], ['連我的恐龍睡衣也可以嗎？', '一定有小朋友會超愛的！']),
    ],
    waiter: [
      topic('跟服務生說聲「謝謝」，會讓我們開心一整天。', ['謝謝你，東西好好吃！', '你讓我整個班都充滿電了！'], ['這份工作很辛苦嗎？', '很忙，不過我喜歡認識新朋友。'], ['我可以當一天服務生嗎？', '哈！先試試一次端三個盤子吧。']),
      topic('盡量把東西吃完，才不會浪費。', ['我只點吃得完的份量。', '聰明，又愛地球。'], ['吃不完的怎麼辦？', '我們會幫客人打包帶回家。'], ['我的寵物會吃我的剩菜。', '要小心喔，有些食物對寵物不好！']),
    ],
    stableKeeper: [
      topic('馬大部分時間都是站著睡覺的喔！', ['哇，真的嗎？', '牠們會把腳鎖住，就不會跌倒。'], ['牠們會躺下來嗎？', '會啊，覺得安全的時候會躺下來熟睡。'], ['我可以站著睡嗎？', '哈！你還是睡床比較好。']),
      topic('幫馬刷毛可以讓你們變成好朋友。', ['我可以刷一匹嗎？', '輕輕的，順著毛長的方向刷。'], ['為什麼會有幫助？', '感覺就像按摩，牠們會慢慢信任你。'], ['牠們會幫我刷回來嗎？', '也許會用鼻子吧！哈！']),
    ],
  },
};
